import React, { Component } from 'react';
import StepSidebar from './StepSidebar';
import { MenuItem } from '@material-ui/core';
import Favo from '../../Favo/Favo';
import styles from './StepMenu.scss';

const rootClassName = styles.rootClassName;

class StepMenu extends Component {
  render() {
    return (
      <MenuItem
        className={rootClassName}
        onClick={this.props.onClick}
        selected={this.props.selected}
        disabled={this.props.disabled}
      >
        <Favo color={this.props.color} className={rootClassName + '-favo'} />
        {this.props.name}
      </MenuItem>
    );
  }
}

StepMenu.propTypes = StepSidebar.propTypes;

export default StepMenu;
